import React from 'react';
import styled, { css } from 'styled-components';
import { Heading } from '../typography';

import { Cash } from '../../assets/icons';

export default function CashOutAlert() {
  return (
    <Wrapper>
      <Label size="xl" weight="regular">
        Ungraded / <Highlight>Cashout Available</Highlight>
        <CashIcon>
          <Cash />
        </CashIcon>
      </Label>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.colors.status.info};
    border-radius: ${theme.borderRadius.xlarge};
    border: 1px solid ${theme.colors.status.info};
    display: flex;
    justify-content: center;
    padding: 2rem 0;
  `};
`;

const Label = styled(Heading)`
  align-items: center;
  color: ${({ theme }) => theme.components.global.textColor};
  display: flex;
  margin: 0;
`;

const Highlight = styled.span`
  color: #128152;
  margin: 0 1rem 0 0.4rem;
`;

const CashIcon = styled.span`
  align-items: center;
  border: 1px solid black;
  border-radius: 100%;
  display: inline-flex;
  justify-content: center;
  width: 3.7rem;
  height: 3.7rem;
`;
